<template>
  <div class="open-hour">
    <div class="form-group row">
      <div class="col-md-2">
        <label for="openhour" class="form-label">Open Hour</label>
      </div>
      <div class="col-md-10 pt-0">
        <div
          v-for="(item, index) of items"
          :key="index"
          class="open-time-record d-flex"
        >
          <div class="col-md-4 pl-0">
            <label for="openhour" class="form-label mb-0">Day</label><br />
            <input
              class="daily mt-0"
              type="text"
              id="date"
              name="date"
              placeholder="daily"
              @change="handleChange"
              v-model="item.day"
            />
          </div>
          <div class="col-md-4 pl-0">
            <label for="openhour" class="form-label mb-0">Opening Time</label
            ><br />
            <input
              class="daily mt-0 pl-10 pr-2 pt-1 pb-1"
              type="time"
              id="date"
              name="date"
              placeholder="--:--"
              @change="handleChange"
              v-model="item.startTime"
            />
            <!-- <button><img  class="up-btn" :src="arrowUp"></button>
          <button><img  class="down-btn" :src="arrowDown"></button> -->
          </div>
          <div class="col-md-4 pl-0">
            <label for="openhour" class="form-label mb-0">Closing Time</label
            ><br />
            <input
              class="daily mt-0 pl-10 pr-2 pt-1 pb-1"
              type="time"
              id="date"
              name="date"
              placeholder="--:--"
              @change="handleChange"
              v-model="item.endTime"
            />
            <!-- <button><img  class="up-btn" :src="arrowUp"></button>
          <button><img  class="down-btn" :src="arrowDown"></button> -->
          </div>
        </div>
      </div>

      <div class="col-md-2"></div>
      <div class="col-md-10">
        <button class="add-btn" @click="onClickAdd">
          <img class="icon-add" :src="iconAdd" />ADD OPENING HOURS
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import iconAdd from "../../assets/images/ew-icon_add.png";
import arrowUp from "../../assets/images/ew-icon_arrow_up.png";
import arrowDown from "../../assets/images/ew-icon_arrow_down.png";

const defaultItem = { day: "", startTime: "", endTime: "" };
export default {
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      items: [],
      iconAdd,
      arrowUp,
      arrowDown,
    };
  },
  mounted() {
    this.revalidate();
  },
  methods: {
    onClickAdd() {
      this.addNewRow();
    },
    addNewRow() {
      this.items.push({ ...defaultItem });
    },
    handleChange() {
      this.$emit("input", this.items);
    },
    revalidate() {
      if (
        typeof this.value === "object" &&
        this.value &&
        this.value.length > 0
      ) {
        this.items = this.value.map((v) => ({
          day: v.day,
          startTime: v.startTime,
          endTime: v.endTime,
        }));
      } else {
        this.items.push({ ...defaultItem });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.open-hour {
  .form-label {
    color: #fff;
  }
  .daily {
    background-color: #fff;
    max-width: 95%;
    text-align: end;
  }
  .add-btn {
    background-color: #1da1f2;
    color: #fff;
    padding: 0 10px 0 2px;
    border-radius: 5px;
    font-size: 14px;
    .icon-add {
      height: 30px;
      width: 30px;
      padding: 5px;
      border: #fff;
      // background-color: #1da1f2;
      z-index: 1;
    }
  }

  .up-btn {
    position: absolute;
    padding: 1.5% 2%;
    left: 37%;
    top: 49%;
    z-index: 10;
    background-color: #1da1f2;
  }
  .down-btn {
    position: absolute;
    padding: 1.5% 2% 1.5%;
    left: 37%;
    top: 65%;
    z-index: 10;
    background-color: #1da1f2;
  }
}
</style>